import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/gifs/crying-man.gif'


const _hoisted_1 = { class: "wrapper px-3 mx-auto" }
const _hoisted_2 = { class: "box has-text-centered" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("img", { src: _imports_0 }, null, -1)),
      _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "bold-text" }, "Oh no! You’re out of leads.", -1)),
      _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
      _cache[5] || (_cache[5] = _createElementVNode("span", null, " To claim more jobs, top up your account by clicking below. ", -1)),
      _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
      _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("button", {
        class: "button is-primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close(true)))
      }, "Get More Leads")
    ])
  ]))
}